import classnames from "classnames";
import "styles/MainContent.scss";

const MainContent = (props) => {

  const mainContentClassName = classnames([
    "main-content",
    { "m-0": props.noMargin || props.mainContentNoMargin },
    { "p-0": props.noPadding || props.mainContentNoPadding },
  ])
  return (
    <div
      className={classnames([
        "main",
        { "main__wide": props.wide },
        { "main__narrow": props.narrow },
        { "m-0": props.noMargin },
        { "p-0": props.noPadding },
      ])}
    >
      <div className={mainContentClassName}>{props.children}</div>
    </div>
  );
};

export default MainContent;
